import React, { useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export default function ExcludePacienteButton({ pacienteId, onDeleted }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    setError('');
    try {
      await onDeleted?.(pacienteId);
      setOpen(false);
    } catch (deleteError) {
      console.error('Error eliminando paciente:', deleteError);
      setError('No se pudo desactivar el paciente.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <IconButton
        color="error"
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
      >
        <DeleteIcon />
      </IconButton>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Confirmar eliminacion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Seguro que quieres desactivar al paciente con ID {pacienteId}?
          </DialogContentText>
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={isDeleting}>Cancelar</Button>
          <Button color="error" onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? 'Eliminando...' : 'Eliminar'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
